import React, { useEffect, useState } from 'react';

const OktaError = ({ error }) => {
  if (error.name && error.message) {
    console.error(error);
    return <p>{`${error.name}: ${error.message}`}</p>;
  }
  return <p>{`Error: ${error.toString()}`}</p>;
};

export default function LoginCallback({
  oktaAuth,
  authState,
  loadingElement = null,
  onAuthResume,
  onTokenRecieved,
  errorComponent,
}) {
  const [callbackError, setCallbackError] = useState(null);

  const ErrorReporter = errorComponent || OktaError;

  useEffect(() => {
    const isInteractionRequired =
      oktaAuth.idx.isInteractionRequired ||
      oktaAuth.isInteractionRequired.bind(oktaAuth);

    if (onAuthResume && isInteractionRequired()) {
      onAuthResume();
      return;
    }

    oktaAuth
      .handleLoginRedirect()
      .then(async () => {
        if (onTokenRecieved) await onTokenRecieved();
      })
      .catch(e => {
        setCallbackError(e);
      });
  }, [oktaAuth]);

  const authError = authState?.error;
  const displayError = callbackError || authError;
  if (displayError) {
    return <ErrorReporter error={displayError} />;
  }

  return loadingElement;
}
